import { render } from "./createServiceInvoiceForm.vue?vue&type=template&id=74d0cb4d"
import script from "./createServiceInvoiceForm.vue?vue&type=script&lang=js"
export * from "./createServiceInvoiceForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__